import {
  qryClusterInfo,
  qryClusterNumberList,
  updateClusterDetails,
} from '@/pages/FTTHConversions/services';


export default {
  namespace: 'ftthConversions',
  state: {
    selectedTab: '0',
    pendingClusterInfo: [],
    acceptedClusterInfo: [],
    rejectedClusterInfo: [],
    clusterNumberList: [],
  },
  effects: {
    *qryClusterInfo({ payload }, { call, put }) {
      const response = yield call(qryClusterInfo, payload);
      if (response.success) {
        yield put({
          type: 'save',
          payload: {
            [payload.flag === 'N' ? 'pendingClusterInfo'
              : [payload.flag === 'Y' ? 'acceptedClusterInfo'
                : 'rejectedClusterInfo']]: response.data?.data?.clusterData,
          },
        });
        return response.data;
      }
      return null;
    },
    *qryClusterNumberList({ payload }, { call, put }) {
      const response = yield call(qryClusterNumberList, payload);
      if (response.success) {
        yield put({
          type: 'save',
          payload: {
            clusterNumberList: response.data?.data?.clusterData,
          },
        });
        return response.data;
      }
      return null;
    },
    *updateClusterDetails({ payload }, { call }) {
      const response = yield call(updateClusterDetails, payload);
      return response;
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
